import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { Asphalt } from '../../classes/asphalt.class';
import { Asphaltmill } from '../../classes/asphaltmill.class';
import { AsphaltmillAsphalt } from '../../classes/asphaltmillasphalt.class';
import { PlanningAsphalt } from '../../classes/planningasphalt.class';
import { AsphaltService } from '../../services/asphalt/asphalt.service';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { ImportAsphaltListDialogComponent } from './import-asphalt-list-dialog/import-asphalt-list-dialog.component';

@Component({
    selector: 'app-asphalt',
    templateUrl: './asphalt.component.html',
    styleUrls: ['./asphalt.component.scss'],
    standalone: false,
})
export class AsphaltComponent implements OnInit {
    public asphaltMills: Asphaltmill[];
    public asphaltList: Asphalt[];

    private subscriptions = new Subscription();

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<AsphaltComponent>,
        private confirmDialogService: ConfirmDialogService,
        private asphaltService: AsphaltService
    ) {}

    ngOnInit() {
        this.loadData();
    }

    close() {
        this.dialogRef.close();
    }

    export() {
        this.asphaltService.exportAsphaltListToExcel().subscribe(data => {
            saveAs(data, 'asfaltlijst.xlsx');
        });
    }

    openImportDialog() {
        const dialogRef = this.dialog.open(ImportAsphaltListDialogComponent, {
            width: '500px',
            maxHeight: '600px',
            data: {},
        });
        this.subscriptions.add(
            dialogRef.afterClosed().subscribe(() => {
                this.loadData(false);
            })
        );
    }

    loadData(cache = true) {
        this.asphaltService.getAsphaltMills$().subscribe(asphaltMill => {
            this.asphaltMills = asphaltMill;
        });
        this.asphaltService.getAsphaltList(cache).then(asphaltList => {
            this.asphaltList = asphaltList;
        });
    }

    public deleteAsfaltMillAsphalt(asphaltmillAsphalt: AsphaltmillAsphalt) {
        this.confirmDialogService
            .confirm({
                title: 'Asfaltsoort van centrale verwijderen',
                text: `Weet u zeker dat u asfaltsoort ${asphaltmillAsphalt.code} wilt verwijderen?`,
                confirm: 'Verwijderen',
                cancel: 'Annuleren',
            })
            .then(
                confirm => {
                    this.asphaltService.deleteAsfaltMillAsphalt(asphaltmillAsphalt).then(
                        result => {
                            this.loadData(false);
                        },
                        error => {
                            const lines = error['error']['error']['data'] as PlanningAsphalt[];
                            const errorList = lines.reduce((accumulator, message) => {
                                return (
                                    accumulator +
                                    `<li>${message.planning.afas_project_id} - ${formatDate(message.time, 'EEEE d MMMM yyyy HH:mm', 'nl')}</li>`
                                );
                            }, '');
                            this.confirmDialogService.confirm({
                                title: 'Fout bij het opslaan1',
                                text: `Er is al gepland met dit asfalt op de volgende datums en projecten:<ul>${errorList}</ul>`,
                                confirm: 'Oké',
                                cancel: null,
                            });
                        }
                    );
                },
                () => {}
            );
    }
}
